var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalculatorMobileBgdBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 86,
    viewBox: "0 0 414 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_984_79350",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 414,
    height: 86
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.207031,
    width: 414,
    height: 85.1812,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_984_79350)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.5937 40.8576C-65.3642 23.9446 -134.331 58.138 -158.82 77.3488L-157.411 101.793L194.151 72.3232C251.981 68.8734 364.291 56.8111 350.89 36.1608C334.14 10.3479 246.923 14.232 202.579 33.7471C158.235 53.2621 114.541 61.9987 14.5937 40.8576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.355 50.3778C42.8162 39.2408 -26.8412 64.2471 -51.7275 78.1424L-50.8462 95.4713L301.113 70.7651C358.978 67.6929 471.472 57.9216 458.526 43.414C442.343 25.2796 355.101 28.9773 310.367 43.3028C265.632 57.6283 221.779 64.2991 122.355 50.3778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.7236 54.8642C-45.8156 43.7271 -115.473 68.7334 -140.359 82.6287L-139.478 99.9577L212.481 75.2515C270.346 72.1792 382.84 62.4079 369.894 47.9003C353.711 29.7659 266.47 33.4636 221.735 47.7891C177 62.1147 133.148 68.7854 33.7236 54.8642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M153.85 41.454C74.3104 30.317 4.65292 55.3233 -20.2334 69.2185L-19.3521 86.5475L332.607 61.8413C390.472 58.7691 502.966 48.9977 490.02 34.4902C473.837 16.3557 386.596 20.0534 341.861 34.379C297.126 48.7045 253.274 55.3753 153.85 41.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M348.13 33.6162C454.205 7.68186 551.891 31.872 587.474 47.2089L588.669 70.7124L109.098 85.6374C30.388 89.4267 -123.152 91.6674 -107.636 70.3167C-88.241 43.6282 30.2982 36.6547 92.7941 49.8504C155.29 63.0462 215.537 66.0341 348.13 33.6162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M262.902 42.516C327.59 5.56471 396.925 20.5557 423.506 32.6701L429.067 56.5178L115.828 119.237C64.6896 130.897 -36.1125 148.389 -30.2156 125.081C-22.8444 95.9463 53.9142 77.0946 97.8088 84.3601C141.703 91.6256 182.042 88.705 262.902 42.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.047 54.1074L93.7306 80.9497L91.8057 90.5101L402.873 159.272L424.047 54.1074Z",
    fill: "white",
    stroke: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorMobileBgdBottom);
export default __webpack_public_path__ + "static/media/calculator-mobile-bgd-bottom.ce71732c6e791a93d247eacc13f1ee0f.svg";
export { ForwardRef as ReactComponent };